var newTabAreasManager = (function () {
    function init(){
        if (!ENV.isEditmode){
            $(document).ready(initTabs);
        }else{
            var navTabs = $('.tab-areas .nav-buttons .nav-tabs');
            navTabs.each(function () {
                var currentNavTabLinks = $(this).find('.nav-link');
                currentNavTabLinks.on('click', function () {
                    var selectedLink = $(this);
                    currentNavTabLinks.each(function () {
                        if ($(this).attr('id')!==selectedLink.attr('id')){
                            $(this).removeClass('active');
                        }else {
                            $(this).addClass('active');
                        }
                    })
                    var tabPanes = selectedLink.closest('.container').find('.tab-content .tab-pane');
                    tabPanes.each(function () {
                        var currentTabPane = $(this);
                        currentTabPane.removeClass('show').removeClass('active')
                        if (currentTabPane.attr('aria-labelledby') === selectedLink.attr('id')){
                            currentTabPane.addClass('active show')
                        }
                    })
                })
            })
        }
    }

    function initTabs(){
        $('.tab-areas').each(function () {
            var currentTab = $(this);
            var navTabs = currentTab.find('.nav-buttons .nav-tabs');
            var navItems = navTabs.find('.nav-item');
            var urlParam = new URLSearchParams(window.location.search).get('tab');
            if (navItems.length>1 && urlParam!==null && urlParam!==''){
                var navLinkActive = $('.nav-link.active', navItems).removeClass('active');
                $(".tab-pane"+navLinkActive.attr('data-target'), currentTab).removeClass('show').removeClass('active')
                $('.nav-link', navItems).each(function () {
                    var currentLink = $(this);
                    if (currentLink.attr('data-open-id') === urlParam){
                        currentLink.tab("show");
                    }
                })
            }

            if (navItems.length>1 && $(window).width()>575 && !currentTab.hasClass("buttons-full-width")){
                var maxWidth = 0;
                navItems.each(function () {
                    $(this).outerWidth('auto');
                    maxWidth = Math.ceil(Math.max($(this).outerWidth(),maxWidth));
                });
                navItems.outerWidth(maxWidth);

                if ( (maxWidth*navItems.length) > navTabs.width() ){
                    navItems.outerWidth(navTabs.width()/navItems.length);
                }
            }
        })
    }

    return {
        init: init
    };
})(jQuery);